import { CLASSROOM_MODULE_FETCH_SECTIONS } from '../actions';
import { fetchSections as fetchSectionsApi } from '../api';
import * as classRoomSelectors from '../../selectors/classroom';

const fetchSectionsAction = (status, payload) => ({
  type: CLASSROOM_MODULE_FETCH_SECTIONS,
  status,
  payload,
});

const fetchSectionsStarted = fetchSectionsAction.bind(null, 'started');
const fetchSectionsSuccess = fetchSectionsAction.bind(null, 'success');
const fetchSectionsError = fetchSectionsAction.bind(null, 'error');

const fetchSections = (classId) => async (dispatch, getState) => {
  const state = getState();
  const classRoomId = classId || classRoomSelectors.currentClassRoomId(state);
  if (!classRoomId) {
    return;
  }

  dispatch(fetchSectionsStarted());

  try {
    const materials = await fetchSectionsApi(classRoomId);
    dispatch(fetchSectionsSuccess({ classRoom: classRoomId, materials }));
  } catch (error) {
    dispatch(fetchSectionsError(error));
  }
};

export default fetchSections;
